import { render, staticRenderFns } from "./SearchForm.vue?vue&type=template&id=1f2463ea"
import script from "./SearchForm.ts?vue&type=script&lang=ts&external"
export * from "./SearchForm.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports